import React from "react";
import {
  Modal,
  Paper,
  Typography,
  IconButton,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { LoadingButton } from "@mui/lab";
import { useAddSection } from "../../../hooks/useSections/useAddSections";

export const AddSection = ({ token, open, close, id_document, refresh }) => {
    const {
      formData,
      errors,
      loading,
      sectionTypes,
      handleChange,
      handleSubmit,
      handleClose,
    } = useAddSection(token, id_document, refresh, close);
  return (
    <Modal open={open} onClose={handleClose}>
      <Paper
        elevation={4}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          p: 3,
          width: { xs: "90%", sm: "80%", md: "70%" },
          maxWidth: "800px",
          maxHeight: "90vh",
          overflowY: "auto",
          borderRadius: 2,
          outline: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            pb: 1,
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Typography variant="h5" fontWeight="500">
            Agregar Sección
          </Typography>
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              bgcolor: "grey.100",
              "&:hover": { bgcolor: "grey.200" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box component="form" noValidate sx={{ mt: 1 }}>
          <Stack spacing={3}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
              <TextField
                fullWidth
                label="Nombre de la sección *"
                name="name_section"
                value={formData.name_section}
                onChange={handleChange}
                error={!!errors.name_section}
                helperText={errors.name_section}
                variant="outlined"
                autoFocus
              />

              <FormControl fullWidth error={!!errors.id_type_section}>
                <InputLabel>Tipo de sección *</InputLabel>
                <Select
                  name="id_type_section"
                  value={formData.id_type_section}
                  onChange={handleChange}
                  label="Tipo de sección *"
                >
                  {sectionTypes.map((type) => (
                    <MenuItem
                      key={type.ID_TIPO_SECCION}
                      value={String(type.ID_TIPO_SECCION)}
                    >
                      {type.NOMBRE_TIPO_SECCION || type.ID_TIPO_SECCION}
                    </MenuItem>
                  ))}
                </Select>
                {errors.id_type_section && (
                  <Typography variant="caption" color="error">
                    {errors.id_type_section}
                  </Typography>
                )}
              </FormControl>
            </Stack>

            
            <TextField
              name="description"
              label="Descripción"
              multiline
              rows={3}
              value={formData.description}
              onChange={handleChange}
              fullWidth
            />
          </Stack>

          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}
          >
            <LoadingButton variant="outlined" onClick={handleClose}>
              Cancelar
            </LoadingButton>
            <LoadingButton
              variant="contained"
              onClick={handleSubmit}
              loading={loading}
              disabled={!formData.name_section.trim()}
            >
              Agregar Sección
            </LoadingButton>
          </Box>
        </Box>
      </Paper>
    </Modal>
  );
};
